import { Onboarding } from '@rulebooks/evidend-titan';
import React from 'react';

import { useOnboarding } from './OnboardingProvider';

export const OnboardingModal = () => {
  const { steps, isShownModal, currentPage, onPageChange, onToggleModal } = useOnboarding();

  if (!steps?.length) return null;

  return (
    <Onboarding
      currentPage={currentPage}
      isShown={isShownModal}
      stepsConfiguration={steps}
      testId="onboardingModal"
      onPageChange={onPageChange}
      onToggle={onToggleModal}
    />
  );
};
